/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Sales_Return_Err_Lot_Shared_MaxInputs */

const vi_sales_return_err_lot_shared_max = /** @type {(inputs: Sales_Return_Err_Lot_Shared_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng số trả của lô này (ở các dòng cùng sản phẩm) vượt ${i?.max}`)
};

/**

* @param {Sales_Return_Err_Lot_Shared_MaxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_err_lot_shared_max = /** @type {((inputs: Sales_Return_Err_Lot_Shared_MaxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Err_Lot_Shared_MaxInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_err_lot_shared_max(inputs)
});